<template>
  <Dialog
    :visible="display"
    :closable="false"
    :showHeader="false"
    :modal="true"
    contentStyle="padding:1.5rem 3rem"
  >
    <div dir="rtl">
      <div style="font-size: 18px; color: #3f3f3f" class="mb-3">
        يوجد بالفعل طلب تسجيل مرتبط بهذا البريد الإلكتروني، هل ترغب في المتابعة به؟
      </div>
      <div
        v-if="charityRequest"
        style="
          font-size: 14px;
          color: #3f3f3f;
          padding: 1rem 0rem;
          border-bottom: 1px solid #ececec;
        "
      >
        <div>اسم الجمعية : {{ charityRequest.charity_name }}</div>
        <!-- status_label is already translated by the backend -->
        <div>حالة الطلب : {{ charityRequest.status_label }}</div>
        <div>تاريخ الطلب : {{ createdOn }}</div>
      </div>
      <div class="row mt-4">
        <div class="col-6">
          <button
            id="existing-request-no-btn"
            class="btn btn-lg btn-secondary btn-block close-btn"
            type="button"
            @click.stop="emit('decline')"
          >
            لا
          </button>
        </div>
        <div class="col-6">
          <button
            id="existing-request-yes-btn"
            class="btn btn-lg btn-primary btn-block tracking-btn"
            type="button"
            @click.stop="emit('reuse')"
          >
            نعم
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Dialog from "primevue/dialog";
import moment from "moment";

import { CharityRegisterInterfaces } from "@/interfaces/charity-register";

const props = defineProps<{
  display: boolean;
  charityRequest: CharityRegisterInterfaces.ICharityRequestSummary | null;
}>();

const emit = defineEmits<{
  (e: "reuse"): void;
  (e: "decline"): void;
}>();

const createdOn = computed(() =>
  props.charityRequest?.created_on
    ? moment(props.charityRequest.created_on).format("YYYY-MM-DD")
    : ""
);
</script>

<style lang="scss" scoped>
.tracking-btn {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  background: #12b2aa;
  color: #ffffff;
  border: none;
  font-size: 18px;
}

.tracking-btn:hover {
  background: #0e8e88;
  border: none;
}

.close-btn {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  background: #d9d9d9;
  color: #3f3f3f;
  border: none;
  font-size: 18px;
}

.close-btn:hover {
  background: #b2b2b2;
  color: #3f3f3f;
  border: none;
}
</style>
